const baseStoreUrl = "Store"



  const endpoints = {
    getInviteListFilter:`${baseStoreUrl}/GetPortfolioUserStoreInvitationList`,
    acceptInvite:`${baseStoreUrl}/AcceptStoreInvitationByPortfolioUser`,
    rejectInvite:`${baseStoreUrl}/RejectStoreInvitationByPortfolioUser`
 
    

   
  };
  
  export default endpoints;
  